import axiosClient from './axiosClient';

export const processParameters = (...params) => {
    const paramsObj = new URLSearchParams();
    params.forEach(([value, key]) => {
        if (value) {
            let parsedValue = value;
            if (Object.prototype.toString.call(value) === '[object Date]') {
                parsedValue = parsedValue.toISOString();
            }
            paramsObj.append(key, parsedValue);
        }
    })
    return paramsObj;
}

export const getConversations = ({ storeId, sort, state, lastMessageTimestamp, totalResults, assignmentFilter, 
    assignedAdminId, userPhone, userName, issueTypes, issueStates }) => {
    const params = processParameters(
        [storeId, "storeId"],
        [sort, "sort"],
        [state, "state"],
        [lastMessageTimestamp, "lastMessageTimestamp"],
        [totalResults, "totalResults"],
        [assignmentFilter, "assignmentFilter"],
        [assignedAdminId, "assignedAdminId"],
        [userPhone, "userPhone"],
        [userName, "userName"],
        [issueTypes, "issueTypes"],
        [issueStates, "issueStates"]
    )
    return axiosClient.get(`/conversations?${params}`)
}

export const getMessagesFromConversaion = ({ conversationId, lastMessageTimestamp, totalResults }) => {
    const params = processParameters(
        [lastMessageTimestamp, "lastMessageTimestamp"],
        [totalResults, "totalResults"]
    )
    return axiosClient.get(`/conversations/${conversationId}/messages?${params}`)
}

export const sendMessage = (body) => {
    return sendMessageFile(body, null)
}

export const sendMessageFile = (message, file) => {
    const msgJson = JSON.stringify(message)
    const msgBlob = new Blob([msgJson], {
        type: 'application/json'
    })
    const formData = new FormData();
    formData.append('message', msgBlob);
    if (file)
        formData.append('attachment', file);

    return axiosClient.post(`/conversations/send`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
          }
    })
}

export const getSourceAccounts = ({ storeId, category }) => {
    return axiosClient.get(`/sources/stores/${storeId}?category=${category}`)
}

export const markConversationAsClosed = (conversationId) => {
    return axiosClient.put(`/conversations/${conversationId}/close`)
}

export const markConversationAsOpen = (conversationId) => {
    return axiosClient.put(`/conversations/${conversationId}/open`)
}

export const setMsgAsRead = (messageId) => {
    return axiosClient.put(`/conversations/messages/${messageId}/viewed`);
}

export const getConversation = (body) => {
    return axiosClient.post(`/conversations`, { ...body })
}

export const getEvolution = (storeIds, period) => {
    const params = processParameters(
        [storeIds, "storeIds"],
        [period && period.from, "dateFrom"],
        [period && period.to, "dateTo"]
    );
    return axiosClient.get(`/conversations/evolution?${params}`)
}

export const getEvolutionCsv = (storeIds, period) => {
    const params = processParameters(
        [storeIds, "storeIds"],
        [period && period.from, "dateFrom"],
        [period && period.to, "dateTo"]
    );
    return axiosClient.get(`/conversations/evolution/csv?${params}`)
}

export const assignConversation = (conversationId, administratorId, comment, notifyUser ) => {
    const params = processParameters(
        [administratorId, "targetAdminId"],
        [comment, "comment"],
        [notifyUser, "notifyUser"]
    );
    return axiosClient.post(`/conversations/${conversationId}/assign?${params}`)
}

export const unassignConversation = (conversationId, comment ) => {
    const params = processParameters(
        [comment, "comment"]
    );
    return axiosClient.post(`/conversations/${conversationId}/unassign?${params}`)
}

export const getConversationById=(conversationId)=>{
    return axiosClient.get(`/conversations/${conversationId}/conversation`)
}

